import { Box, Container, Divider, Tab, Tabs, Typography } from '@mui/material'
import { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useAppSelector } from 'src/store/hooks'
import {
  selectSeriesByID,
  selectSeasonsInSeries,
  selectCourses,
  selectClasses,
} from 'src/v3/self-paced/self-paced.slice'
import { onCourseImageError } from 'src/v3/self-paced/utils/course-thumbnail'

export default () => {
  let { seriesID } = useParams()
  let navigate = useNavigate()
  let series = useAppSelector(selectSeriesByID(seriesID ?? ''))
  let seasons = useAppSelector(selectSeasonsInSeries(seriesID ?? ''))
  let courses = useAppSelector(selectCourses)
  let classes = useAppSelector(selectClasses)
  let [season, setSeason] = useState(1)

  return (
    <>
      {!!series?.banner && (
        <img
          src={`${import.meta.env.VITE_CLOUDFRONT_URL}/public/${series?.banner}`}
          style={{ width: '100%', height: 'auto' }}
        />
      )}
      <Container maxWidth="xl">
        <Typography variant="subtitle1" sx={{ textAlign: 'center', my: 4 }}>
          {series?.description}
        </Typography>
        <Box sx={{ width: '100%' }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs
              value={season}
              onChange={(_, newValue: number) => setSeason(newValue)}
              aria-label="Seasons"
            >
              {seasons.map((s) => (
                <Tab label={`Season ${s}`} key={s} value={s} />
              ))}
            </Tabs>
          </Box>
        </Box>
        {series?.courses
          .filter((c) => c.season === season)
          .map((c) => {
            let course = courses.find((co) => co.id === c.courseID)
            return (
              <div key={c.courseID}>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: {
                      xs: 'column',
                      md: 'row',
                    },
                    marginTop: 4,
                    cursor: 'pointer',
                    alignItems: {
                      xs: 'center',
                      md: 'flex-start',
                    },
                  }}
                  onClick={() => {
                    navigate(`/self-paced/course/${c.courseID}`)
                  }}
                >
                  <Box sx={{ minWidth: '300px' }}>
                    {course?.imageName && (
                      <img
                        src={`${import.meta.env.VITE_CLOUDFRONT_URL}/public/${course?.imageName}`}
                        onError={(event) =>
                          onCourseImageError(event, course?.imageName)
                        }
                        style={{ width: '300px', height: 'auto' }}
                      />
                    )}
                  </Box>
                  <Box sx={{ marginLeft: 4 }}>
                    <Typography variant="h6" sx={{ mt: 2 }}>
                      {course?.name}
                    </Typography>
                    <Typography variant="body2" sx={{ mt: 2 }}>
                      {
                        classes.find((cls) => cls.courseID === course?.id)
                          ?.description
                      }
                    </Typography>
                  </Box>
                </Box>
                <Divider
                  sx={{
                    my: 4,
                    display: {
                      xs: 'block',
                      md: 'none',
                    },
                  }}
                />
              </div>
            )
          })}
      </Container>
    </>
  )
}
